import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import RetentionContent from '@UI/Pages/Administration/Retention/RetentionContent';
import RetentionNotifications from '@UI/Pages/Administration/Retention/RetentionNotifications';
import type * as React from 'react';

const RetentionPage: React.FC = () => {
	return (
		<PageContainer width="sm">
			<PageHeader
				eyebrow="ADMINISTRATION · CONFORMITÉ"
				title="Rétention & purge"
				description="Deux durées, deux portées : l'enregistrement audio, et le dossier archivé dans son ensemble."
			/>
			<RetentionContent />
			<RetentionNotifications />
		</PageContainer>
	);
};

export default RetentionPage;
